/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, {Component} from "react";
import {Link} from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import Select from "react-select";
import {connect} from "react-redux";
import {logout, addArtwork} from "./Redux/actions/user";
const IpfsHttpClient = require("ipfs-http-client");

const ipfs = IpfsHttpClient({
  host: "ipfs.infura.io",
  port: 5001,
  protocol: "https",
});

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user && this.props.user.user ? this.props.user.user : {},
      isAdd: false,
      fullname: "",
      natureCol: "",
      name: "",
      authors: [],
      type: {},
      files: [],
      precNature: false,
      buffer: null,
      uploading: false,
      date_start: new Date(),
      date_finised: new Date(),
      date_publish: new Date(),
      percent: null,
      details: "",
      imaging: false,
    };
  }

  captureFile = async (event) => {
    event.preventDefault();
    let self = this;

    if (
      event.target.files &&
      event.target.files[0] &&
      this.state.files.length < 2
    ) {
      let file = event.target.files[0];
      let typeFile = file.type;

      if (this.state.files.length === 0 && !typeFile.includes("image")) {
        alert("Ajout un fichier image svp");
      } else if (this.state.files.length === 1 && !typeFile.includes("audio")) {
        alert("Ajout un fichier audio svp");
      } else {
        self.setState({imaging: true});
        const reader = new window.FileReader();
        reader.readAsArrayBuffer(file);
        reader.onloadend = async () => {
          for await (const file of ipfs.add(Buffer(reader.result))) {
            if (file && file.path) {
              self.setState(
                {
                  files: [...self.state.files, {id: file.path, type: typeFile}],
                  imaging: false,
                },
                () => console.log(self.state.files)
              );
            }
          }
        };

        // this.setState({buffer: Buffer(reader.result)});
        // console.log("buffer", this.state.buffer);
      }
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    if (
      this.state.authors.length > 0 &&
      this.state.authors.reduce((a, b) => a + b.percent, 0) / 100 !== 1
    ) {
      alert("Mauvaise repartition des parts");
    } else if (this.state.name === "") {
      alert("SVP ajouter un titre");
    } else if (this.state.files.length < 2) {
      alert("SVP ajouter une image et un audio");
    } else if (!this.state.type.value) {
      alert("SVP selectionner une categorie");
    } else {
      this.props.addArtwork(
        {
          users: [this.state.user._id],
          name: this.state.name,
          date_start: this.state.date_start,
          date_finised: this.state.date_finised,
          date_publish: this.state.date_publish,
          collaborators: this.state.authors,
          type: this.state.type,
          files: this.state.files,
        },
        this.props.user.jwt
      );
    }
  };

  componentDidMount() {}

  render() {
    return (
      <div id="content">
        <div className="rn-blog-area rn-section-gap bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title section-title--2 text-center">
                  <h2 className="title">Liste de vos oeuvres</h2>
                  <p>
                    Le moyen le plus simple et le plus rapide d'ecouter votre
                    audience radiophonique.
                  </p>
                  {this.state.type.value !== "artistique" ? (
                    <Link to="listen" style={{margin: 10}}>
                      <button
                        onClick={() => {
                          localStorage.setItem(
                            "artist",
                            this.state.user.username
                          );
                          localStorage.setItem("title", "");
                        }}
                        style={{width: 200}}
                        className="btn btn-primary btn-lg btn_solid">
                        Statistiques
                      </button>
                    </Link>
                  ) : null}
                  <button
                    style={{margin: 10, width: 200}}
                    data-toggle="modal"
                    data-target="#exampleModal"
                    data-whatever="@getbootstrap"
                    className="btn btn-danger btn-lg btn_solid">
                    Ajouter
                  </button>

                  {/* <button
                    style={{margin: 10, width: 200}}
                    data-toggle="modal"
                    data-target="#createContractModal"
                    data-whatever="@getbootstrap"
                    className="btn btn-success btn-lg btn_solid">
                    Creons ensemble
                  </button> */}
                </div>
              </div>
            </div>
            <div className="row mt--20">
              {/* Start Blog Area  */}
              {this.props.tasks.map((task, key) => (
                <div
                  className="col-lg-4 col-md-6 col-sm-12"
                  key={key}
                  style={{minWidth: 370}}>
                  <div className="blog blog-style--1">
                    <div className="">
                      <a href="blog-details.html">
                        <img
                          style={{height: 300, objectFit: "cover"}}
                          className="w-100"
                          src={`https://ipfs.infura.io/ipfs/${task.files[0].id}`}
                          alt="Blog Images"
                        />
                      </a>
                    </div>
                    <div className="content">
                      <p className="blogtype">
                        {" "}
                        {task.type.value.toUpperCase()}
                      </p>
                      <h4 className="title">
                        <a href="blog-details.html">{task.name}</a>
                      </h4>
                      {task.type.value.toUpperCase() !==
                      "Arts visuels".toUpperCase() ? (
                        <div className="blog-btn">
                          <a
                            href={"/listen"}
                            style={{textDecoration: "none"}}
                            className="rn-btn text-white"
                            onClick={() => {
                              localStorage.setItem(
                                "artist",
                                this.state.user.username
                              );
                              localStorage.setItem("title", task.name);
                            }}>
                            Diffusions
                          </a>
                          <br />
                          {task.files && task.files[1] ? (
                            <audio
                              oncontextmenu="return false;"
                              controls
                              controlsList="nodownload"
                              style={{marginTop: 10}}>
                              <source
                                src={`https://ipfs.infura.io/ipfs/${task.files[1].id}`}
                                type={task.files[1].type}
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : null}
                        </div>
                      ) : (
                        <div className="blog-btn">
                          <a
                            className="rn-btn text-white"
                            onClick={() => {
                              alert(
                                "Cette fonctionnalité n'est pas encore disponible pour les Arts visuels"
                              );
                            }}>
                            Vérification
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="rn-pagination text-center mt--60 mt_sm--30">
                  <ul className="page-list">
                    <li className="active">
                      <a href="#">1</a>
                    </li>
                    {/* <li>
                      <a href="#">2</a>
                    </li>
                    <li className="active">
                      <a href="#">3</a>
                    </li>
                    <li>
                      <a href="#">4</a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            <div className="contact-form--1" style={{width: "100%"}}>
              <div className="container">
                <div className="row align-items-start">
                  <div
                    className="modal bd-example-modal-lg"
                    id="exampleModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static">
                    <div className="modal-dialog modal-lg" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="exampleModalLabel">
                            Nouveau
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="col-lg-12">
                            <div className="form-wrapper">
                              <form
                                // onSubmit={(event) => {
                                //   event.preventDefault();
                                //   this.props.createTask(
                                //     this.title.value,
                                //     this.category.value,
                                //     this.content.value,
                                //     JSON.stringify(this.state.authors)
                                //   );
                                // }}

                                onSubmit={this.onSubmit}>
                                <div className="row">
                                  <div className="col-lg-6  col-sm-12">
                                    <label>
                                      <input
                                        id="titre"
                                        onChange={(input) => {
                                          this.setState({
                                            name: input.target.value,
                                          });
                                        }}
                                        type="text"
                                        className="form-control"
                                        placeholder="Title"
                                        required
                                      />
                                    </label>

                                    <label className="">
                                      <Select
                                        options={
                                          this.state.user && this.state.user._id
                                            ? this.state.user.categories
                                            : []
                                        }
                                        onChange={(input) => {
                                          this.setState({type: input});
                                        }}
                                      />
                                    </label>
                                    <br />
                                    <label className="">
                                      <div className="row">
                                        <div className="col-lg-6">
                                          <p style={{color: "#aaa"}}>
                                            Date demarrage
                                          </p>
                                        </div>
                                        <div className="col-lg-6">
                                          <DatePicker
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            selected={this.state.date_start}
                                            onChange={(date) => {
                                              this.setState({date_start: date});
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </label>
                                    <label className="">
                                      <div className="row">
                                        <div className="col-lg-6">
                                          <p style={{color: "#aaa"}}>
                                            Date finition
                                          </p>
                                        </div>
                                        <div className="col-lg-6">
                                          <DatePicker
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            selected={this.state.date_finised}
                                            onChange={(date) => {
                                              this.setState({
                                                date_finised: date,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </label>
                                    <label className="">
                                      <div className="row">
                                        <div className="col-lg-6">
                                          <p style={{color: "#aaa"}}>
                                            Date de publication
                                          </p>
                                        </div>
                                        <div className="col-lg-6">
                                          <DatePicker
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            selected={this.state.date_publish}
                                            onChange={(date) => {
                                              this.setState({
                                                date_publish: date,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </label>

                                    <label>
                                      Image
                                      <input
                                        type="file"
                                        onChange={this.captureFile}
                                        id="file"
                                        className="form-control"
                                        placeholder="File"
                                      />
                                    </label>
                                    {this.state.files.length > 0 ? (
                                      <label>
                                        Audio
                                        <input
                                          type="file"
                                          onChange={this.captureFile}
                                          id="file"
                                          className="form-control"
                                          placeholder="File"
                                        />
                                      </label>
                                    ) : null}
                                    <div className="row">
                                      {this.state.files &&
                                      this.state.files[0] ? (
                                        <img
                                          className="col-md-3"
                                          src={`https://ipfs.infura.io/ipfs/${this.state.files[0].id}`}
                                          style={{
                                            height: 100,
                                            width: 100,
                                            margin: 5,
                                            objectFit: "cover",
                                          }}
                                        />
                                      ) : null}
                                      {this.state.files &&
                                      this.state.files[1] ? (
                                        <audio controls className="col-md-9">
                                          <source
                                            src={`https://ipfs.infura.io/ipfs/${this.state.files[1].id}`}
                                            type={this.state.files[1].type}
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="col-lg-6  col-sm-12">
                                    <label>
                                      <input
                                        id="fullname"
                                        onChange={(input) =>
                                          this.setState({
                                            fullname: input.target.value,
                                          })
                                        }
                                        value={this.state.fullname}
                                        type="text"
                                        className="form-control"
                                        placeholder="Nom complet"
                                      />
                                    </label>

                                    {this.state.natureCol !== "Autre" &&
                                    this.state.precNature === false ? (
                                      <label>
                                        <div className="form-group">
                                          <select
                                            className="form-control"
                                            id="exampleFormControlSelect1"
                                            value={this.state.natureCol}
                                            onChange={(input) =>
                                              this.setState(
                                                {
                                                  natureCol: input.target.value,
                                                  precNature:
                                                    input.target.value ===
                                                    "Autre",
                                                },
                                                () => {
                                                  if (
                                                    this.state.precNature ===
                                                    true
                                                  ) {
                                                    this.setState({
                                                      natureCol: "",
                                                    });
                                                  }
                                                }
                                              )
                                            }>
                                            <option>
                                              Nature de la collaboration
                                            </option>
                                            <option>Auteur</option>
                                            <option>Compositeur</option>
                                            <option>Auteur/Compositeur</option>
                                            <option>Chanteur</option>
                                            <option>Financière</option>
                                            <option>Autre</option>
                                          </select>
                                        </div>
                                      </label>
                                    ) : (
                                      <label>
                                        <input
                                          id="nature"
                                          onChange={(input) =>
                                            this.setState({
                                              natureCol: input.target.value,
                                            })
                                          }
                                          value={this.state.natureCol}
                                          type="text"
                                          className="form-control"
                                          placeholder="Preciser la Nature"
                                        />
                                      </label>
                                    )}
                                    <label>
                                      <input
                                        id="percent"
                                        onChange={(input) => {
                                          this.setState({
                                            percent: input.target.value,
                                          });
                                        }}
                                        value={this.state.percent}
                                        type="number"
                                        className="form-control"
                                        placeholder="Part de l'oeuvre en %"
                                      />
                                    </label>
                                    <label>
                                      <input
                                        id="info"
                                        onChange={(input) => {
                                          this.setState({
                                            details: input.target.value,
                                          });
                                        }}
                                        value={this.state.details}
                                        type="text"
                                        className="form-control"
                                        placeholder="Details (Facultatif)"
                                      />
                                    </label>
                                    <center>
                                      <span
                                        style={{}}
                                        className="btn btn-primary bnt-sm"
                                        onClick={() => {
                                          if (
                                            this.state.authors.length > 0 &&
                                            this.state.authors.reduce(
                                              (a, b) => a + b.percent,
                                              0
                                            ) +
                                              parseFloat(this.state.percent) >
                                              100
                                          ) {
                                            alert(
                                              "Tout les parts ont été distribué"
                                            );
                                          } else if (
                                            this.state.natureCol !== "Autre" &&
                                            this.state.natureCol !==
                                              "Nature collaboration"
                                          ) {
                                            this.setState(
                                              {
                                                authors: [
                                                  ...this.state.authors,
                                                  {
                                                    fullname: this.state
                                                      .fullname,
                                                    nature: this.state
                                                      .natureCol,
                                                    percent: parseFloat(
                                                      this.state.percent
                                                    ),
                                                    details: this.state.details,
                                                  },
                                                ],
                                              },
                                              () => {
                                                this.setState({
                                                  natureCol: "",
                                                  fullname: "",
                                                  precNature: false,
                                                  percent: 0,
                                                  details: "",
                                                });
                                              }
                                            );
                                          }
                                        }}>
                                        Ajouter à la liste
                                      </span>
                                    </center>

                                    <br />

                                    <label>
                                      <p>
                                        Restant:{" "}
                                        {100 -
                                          this.state.authors.reduce(
                                            (a, b) => a + b.percent,
                                            0
                                          ) +
                                          "%"}
                                      </p>
                                      <ul>
                                        {this.state.authors.map((aut, key) => (
                                          <li style={{fontSize: 12}} key={key}>
                                            {aut.fullname} - {aut.nature} -{" "}
                                            {aut.percent + "%"}
                                          </li>
                                        ))}
                                      </ul>
                                    </label>
                                  </div>
                                </div>
                                <br />
                                <br />
                                <center>
                                  {this.state.imaging === false ? (
                                    <button
                                      // hidden={true}
                                      className="rn-button-style--2 btn_solid"
                                      type="submit"
                                      value="submit"
                                      name="submit"
                                      id="mc-embedded-subscribe">
                                      Envoyer pour validation
                                    </button>
                                  ) : (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <a className="rn-button-style--2 btn_solid">
                                      Entrain de chargé...
                                    </a>
                                  )}
                                </center>

                                <br />
                                <br />
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="modal bd-example-modal-lg"
                    id="createContractModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static">
                    <div className="modal-dialog modal-lg" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="exampleModalLabel">
                            Nouveau contrat
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="col-lg-12">
                            <div className="form-wrapper">
                              <form
                                // onSubmit={(event) => {
                                //   event.preventDefault();
                                //   this.props.createTask(
                                //     this.title.value,
                                //     this.category.value,
                                //     this.content.value,
                                //     JSON.stringify(this.state.authors)
                                //   );
                                // }}

                                onSubmit={this.onSubmit}>
                                <div className="row">
                                  <div className="col-lg-6 col-sm-12">
                                    <label>
                                      <input
                                        id="fullname"
                                        onChange={(input) =>
                                          this.setState({
                                            fullname: input.target.value,
                                          })
                                        }
                                        value={this.state.fullname}
                                        type="text"
                                        className="form-control"
                                        placeholder="Nom complet"
                                      />
                                    </label>

                                    {this.state.natureCol !== "Autre" &&
                                    this.state.precNature === false ? (
                                      <label>
                                        <div className="form-group">
                                          <select
                                            className="form-control"
                                            id="exampleFormControlSelect1"
                                            value={this.state.natureCol}
                                            onChange={(input) =>
                                              this.setState(
                                                {
                                                  natureCol: input.target.value,
                                                  precNature:
                                                    input.target.value ===
                                                    "Autre",
                                                },
                                                () => {
                                                  if (
                                                    this.state.precNature ===
                                                    true
                                                  ) {
                                                    this.setState({
                                                      natureCol: "",
                                                    });
                                                  }
                                                }
                                              )
                                            }>
                                            <option>
                                              Nature de la collaboration
                                            </option>
                                            <option>Auteur</option>
                                            <option>Compositeur</option>
                                            <option>Auteur/Compositeur</option>
                                            <option>Chanteur</option>
                                            <option>Financière</option>
                                            <option>Autre</option>
                                          </select>
                                        </div>
                                      </label>
                                    ) : (
                                      <label>
                                        <input
                                          id="nature"
                                          onChange={(input) =>
                                            this.setState({
                                              natureCol: input.target.value,
                                            })
                                          }
                                          value={this.state.natureCol}
                                          type="text"
                                          className="form-control"
                                          placeholder="Preciser la Nature"
                                        />
                                      </label>
                                    )}
                                    <label>
                                      <input
                                        id="percent"
                                        onChange={(input) => {
                                          this.setState({
                                            percent: input.target.value,
                                          });
                                        }}
                                        value={this.state.percent}
                                        type="number"
                                        className="form-control"
                                        placeholder="Part de l'oeuvre en %"
                                      />
                                    </label>
                                    <label>
                                      <input
                                        id="info"
                                        onChange={(input) => {
                                          this.setState({
                                            details: input.target.value,
                                          });
                                        }}
                                        value={this.state.details}
                                        type="text"
                                        className="form-control"
                                        placeholder="Details (Facultatif)"
                                      />
                                    </label>
                                    <center>
                                      <span
                                        style={{}}
                                        className="btn btn-primary bnt-sm"
                                        onClick={() => {
                                          if (
                                            this.state.authors.length > 0 &&
                                            this.state.authors.reduce(
                                              (a, b) => a + b.percent,
                                              0
                                            ) /
                                              100 ===
                                              1
                                          ) {
                                            alert(
                                              "Tout les parts ont été distribué"
                                            );
                                          } else if (
                                            this.state.natureCol !== "Autre" &&
                                            this.state.natureCol !==
                                              "Nature collaboration"
                                          ) {
                                            this.setState(
                                              {
                                                authors: [
                                                  ...this.state.authors,
                                                  {
                                                    fullname: this.state
                                                      .fullname,
                                                    nature: this.state
                                                      .natureCol,
                                                    percent: parseFloat(
                                                      this.state.percent
                                                    ),
                                                    details: this.state.details,
                                                  },
                                                ],
                                              },
                                              () => {
                                                this.setState({
                                                  natureCol: "",
                                                  fullname: "",
                                                  precNature: false,
                                                  percent: 0,
                                                  details: "",
                                                });
                                              }
                                            );
                                          }
                                        }}>
                                        Ajouter à la liste
                                      </span>
                                    </center>

                                    <br />
                                  </div>

                                  <div className="col-lg-6  col-sm-12">
                                    <label>
                                      <p>
                                        Restant:{" "}
                                        {100 -
                                          this.state.authors.reduce(
                                            (a, b) => a + b.percent,
                                            0
                                          ) +
                                          "%"}
                                      </p>
                                      <ul>
                                        {this.state.authors.map((aut, key) => (
                                          <li style={{fontSize: 12}} key={key}>
                                            {aut.fullname} - {aut.nature} -{" "}
                                            {aut.percent + "%"}
                                          </li>
                                        ))}
                                      </ul>
                                    </label>
                                  </div>
                                </div>
                                <br /> <br /> <br />
                                <center>
                                  <button
                                    disabled
                                    // hidden={true}
                                    className="rn-button-style--2 btn_solid"
                                    type="submit"
                                    value="submit"
                                    name="submit"
                                    id="mc-embedded-subscribe">
                                    Validation du contrat (Not dev yet)
                                  </button>
                                </center>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(logout());
    },
    addArtwork: (data, token) => {
      dispatch(addArtwork(data, token));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
